import React from "react";
import { Link } from "react-router-dom";

export default function PageHero({ kicker, title, description, primary, secondary, image }) {
  return (
    <section className="hero-gradient text-white relative overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0b1f3b] via-[#0b1f3b]/85 to-[#0b1f3b]/55" />
        </div>
      )}
      <div className="container-x py-14 md:py-20 relative">
        {kicker && <div className="kicker text-[var(--melopa-gold-soft)] mb-3">{kicker}</div>}
        <h1 className="text-3xl md:text-5xl font-extrabold leading-tight tracking-tight max-w-3xl">{title}</h1>
        {description && <p className="text-white/85 mt-4 max-w-2xl text-base md:text-lg">{description}</p>}
        {(primary || secondary) && (
          <div className="mt-7 flex flex-wrap gap-3">
            {primary && (primary.href ? (
              <a href={primary.href} target="_blank" rel="noreferrer" className="btn-gold" data-testid="page-hero-primary">{primary.label}</a>
            ) : (
              <Link to={primary.to} className="btn-gold" data-testid="page-hero-primary">{primary.label}</Link>
            ))}
            {secondary && (secondary.href ? (
              <a href={secondary.href} target="_blank" rel="noreferrer" className="btn-outline-white" data-testid="page-hero-secondary">{secondary.label}</a>
            ) : (
              <Link to={secondary.to} className="btn-outline-white" data-testid="page-hero-secondary">{secondary.label}</Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
